import { Component, inject, signal, output } from '@angular/core';
import { EncryptionService } from '../../../services/encryption.service';
import {
  ActionButtonsComponent,
  asActionButtonVariant,
} from '../../action-buttons/action-buttons';

@Component({
  selector: 'app-lock-form',
  standalone: true,
  imports: [ActionButtonsComponent],
  templateUrl: './lock-form.html',
  styleUrl: './lock-form.css',
})
export class LockFormComponent {
  private readonly encryptionService = inject(EncryptionService);

  // Component signals
  isSubmitting = signal<boolean>(false);

  // Output events
  locked = output<void>();
  cancelled = output<void>();
  generateKey = output<void>();

  /**
   * Handles locking the data (re-encrypt)
   */
  handleLock(): void {
    // Set loading state
    this.isSubmitting.set(true);

    // Call encryption service to lock data
    this.encryptionService.lockData().subscribe({
      next: () => {
        location.reload();
      },
      error: () => {
        this.isSubmitting.set(false);
        // Error will be handled by the parent or shown in the form
      },
    });
  }

  /**
   * Handles navigation to generate new key
   */
  handleGenerateKey(): void {
    this.generateKey.emit();
  }

  /**
   * Handles close button click
   */
  handleClose(): void {
    this.cancelled.emit();
  }

  /**
   * Handle action button clicks
   */
  onActionButtonClick(buttonId: string): void {
    switch (buttonId) {
      case 'lock-data-btn':
        this.handleLock();
        break;
      case 'generate-new-key-btn':
        this.handleGenerateKey();
        break;
    }
  }

  asActionButtonVariant = asActionButtonVariant;
}
